import { render, staticRenderFns } from "./tx-subject-prefer.vue?vue&type=template&id=5764d6b8&"
import script from "./tx-subject-prefer.ts?vue&type=script&lang=ts&"
export * from "./tx-subject-prefer.ts?vue&type=script&lang=ts&"
import style0 from "./tx-subject-prefer.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports